import { render, staticRenderFns } from "./ProductFinder.vue?vue&type=template&id=6f2461b0&scoped=true"
import script from "./ProductFinder.vue?vue&type=script&lang=ts"
export * from "./ProductFinder.vue?vue&type=script&lang=ts"
import style0 from "./ProductFinder.vue?vue&type=style&index=0&id=6f2461b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f2461b0",
  null
  
)

export default component.exports